"use client";
import * as React from "react";
const SvgArrowBackwardRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.973 6.97H3.503l5.012-5.012c.4-.4.4-1.057 0-1.458-.4-.4-1.048-.4-1.448 0L.3 7.267c-.4.4-.4 1.047 0 1.448l6.767 6.766a1.023 1.023 0 1 0 1.448-1.447L3.504 9.023h11.47A1.03 1.03 0 0 0 16 7.996a1.03 1.03 0 0 0-1.027-1.027Z" }));
export {
  SvgArrowBackwardRound as default
};
